import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Typography, CircularProgress, Alert, Button } from '@mui/material';

function VerifyEmailPage() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        const verify = async () => {
            if (!token) {
                setError('Verification token is missing.');
                setLoading(false);
                return;
            }
            try {
                const { data } = await axios.get(`/api/auth/verify-email/${token}`);
                setMessage(data.message);
            } catch (err) {
                setError(err.response?.data?.message || 'Verification failed.');
            } finally {
                setLoading(false);
            }
        };
        verify();
    }, [token]);

    return (
        <Box textAlign="center" mt={5}>
            <Typography variant="h4" gutterBottom>Email Verification</Typography>
            {loading && <CircularProgress />}
            {message && <Alert severity="success">{message}</Alert>}
            {error && <Alert severity="error">{error}</Alert>}
            <Button variant="contained" sx={{ mt: 3 }} onClick={() => navigate('/login')}>
                Go to Login
            </Button>
        </Box>
    );
}

export default VerifyEmailPage;
